<template>
  <v-card class="main-content-card" flat>
    
    <v-toolbar flat>
      <v-toolbar-title>功能</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn color="primary" class="ml-3"
             :disabled="!funcIds.includes('c_syst_func')"
             @click.native.stop="() => { editDbid = null; edit = true; }">新建功能
      </v-btn>
    </v-toolbar>
    <v-divider/>

    <!-- 检索功能区 -->
    <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
      <v-layout row wrap>
        <v-flex d-flex xs10>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                label="名称"
                v-model="form.name"
                :clearable="true"
                hide-details
              />
            </v-flex>
            <v-flex xs12>
              <span>状态：</span>
              <v-btn-toggle
                v-model="form.disabled"
                class="transparent"
                style="background:none;box-shadow:none"
              >
                <v-btn flat value=""><span>全部</span></v-btn>
                <v-btn flat value="T"><span>禁用</span></v-btn>
                <v-btn flat value="F"><span>启用</span></v-btn>
              </v-btn-toggle>
            </v-flex>

          </v-layout>
        </v-flex>
        <v-flex d-flex xs2 text-xs-center>
          <div>
            <v-btn color="primary" @click="onSearch">
              <v-icon dark>search</v-icon>
              检索
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider/>
    <v-data-table
      :headers="headers"
      :loading="loading"
      item-key="dbid"
      :pagination.sync="query"
      :items="pageResult.items"
      :total-items="pageResult.total"
      :rows-per-page-items="[10, 25, 50, 100, 200]"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{ props.item.identifier }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.disabled === true ? "是" : "否" }}</td>
        <td>
          <p v-for="a in props.item.restApis" style="margin-bottom: 3px">
            <span style="display:inline-block;width:5em">{{a.method}}</span> {{a.url}}
          </p>
        </td>
        <td>{{ props.item.note }}</td>

        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { viewDbid = props.item.dbid; view = true; }">
              <v-icon color="teal">more_horiz</v-icon>
            </v-btn>
            <span>查看</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   :disabled="!funcIds.includes('u_syst_func')"
                   @click="() => { editDbid = props.item.dbid; edit = true; }">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   :disabled="!funcIds.includes('d_syst_func')"
                   @click="() => { deleDbid = props.item.dbid; deleMsg = props.item.name; dele = true; }">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <x-view
      v-model="view"
      :dbid="viewDbid"
    />

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      v-on:ok="onEditOk"
    />

    <x-delete
      v-model="dele"
      :message="deleMsg"
      :uri="uri"
      :dbid="deleDbid"
      v-on:ok="onDeleOk"
    />

  </v-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  import XView from './View'
  import XEdit from './Edit'
  import XDelete from '../../global/Delete'

  import mixin from '@/mixin'

  const baseUri = '/api/syst/function';

  export default {
    // 混入模块主页面（index）基本功能
    mixins: [mixin.index(baseUri)],

    components: {XView, XEdit, XDelete},

    data() {
      return {
        uri: baseUri,
        // 检索、分页、排序条件条件
        query: {
          name: '',
          disabled: '',

          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          descending: null,
          totalItems: null
        },

        // 检索框
        form: {
          name: '',
          disabled: ''
        },

        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "20"},
          {text: '功能标识', align: 'left', sortable: true, value: 'identifier'},
          {text: '功能名称', align: 'left', sortable: true, value: 'name'},
          {text: '禁用', align: 'left', sortable: true, value: 'disabled'},
          {text: '需要的API', align: 'left', sortable: true, value: 'restApis'},
          {text: '备注', align: 'left', sortable: true, value: 'parentId'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid', width: "180"}
        ],

        view: false,
        viewDbid: null,

        edit: false,
        editDbid: null,

        dele: false,
        deleDbid: null,
        deleMsg: null
      }
    },


    computed: {
      ...mapGetters(['funcIds'])
    },

    methods: {
      // 检索响应函数
      onSearch() {
        Object.assign(this.query, this.form);
        this.query.page = 1;
        this.doRoute(this.query);
      },
    }
  }
</script>
